import React from 'react'
import { ErrorMessage } from 'formik'
import './index.css'

const CustomErrorMessage = props => (
  <ErrorMessage {...props} className="cookunity__form_error_message" />
)

export default CustomErrorMessage



// WEBPACK FOOTER //
// ./src/components/Form/ErrorMessage.jsx